import { IGetBriefInvoiceAggregation } from "./briefInvoice";
import { IGetBriefLedgerAggregation } from "./briefLedger";
import { IPagination } from "./user";

export interface IPaymentHistory {
  createdOn: string;
  name: string;
  remarks: string[];
  userId: string;
  userType: string;
}

export interface IPaymentBrandInfo {
  _id: string;
  logoUrl: string;
  name: string;
  companyName: string;
  brandId: string;
}

export enum PAYMENT_TYPE {
  Debit = "Debit",
  Credit = "Credit",
}

export interface IBriefPayment {
  _id: string;
  brand: string;
  brandId: string;
  billing: string;
  billingId: string;
  brief: string;
  briefId: string;
  title: string;
  type: PAYMENT_TYPE;
  proofUrl: string;
  isTdsDeducted?: boolean;
  tdsAmount?: number;
  isTdsReceived?: boolean;
  amountReceived: number;
  createdBy: string;
  createdByModelName: string;
  createdByType: string;
  updatedBy: string;
  updatedByModelName: string;
  updatedByType: string;
  history: IPaymentHistory[];
  createdAt: string;
  updatedAt: string;
  __v: number;
  brandPaymentId: string;
}

export interface IGetBriefPayments {
  data: IBriefPayment[];
  pagination: IPagination;
}

export interface IGetBriefPaymentFacets {
  billing: { name: string; _id: string }[];
  type: { _id: string }[];
}
export interface IGetBriefPaymentAggregation {
  debits: { amountReceived: number; tdsAmount: number };
  credits: { amountReceived: number; tdsAmount: number };
  all: { amountReceived: number; tdsAmount: number };
}

export interface ICreateBriefPayment {
  briefId: string;
  title: string;
  type: PAYMENT_TYPE;
  proofUrl: string;
  isTdsDeducted?: boolean;
  tdsAmount?: number;
  isTdsReceived?: boolean;
  amountReceived: number;
}

export interface IEditBriefPayment {
  brandPaymentId: string;
  title: string;
  type: PAYMENT_TYPE;
  proofUrl: string;
  isTdsDeducted?: boolean;
  tdsAmount?: number;
  isTdsReceived?: boolean;
  amountReceived: number;
}

export interface IBriefPaymentSearchRequest {
  briefId: string;
  searchQuery?: string;
  type?: PAYMENT_TYPE[];
  billingId?: string[];
  createdAtFrom: string;
  createdAtTo: string;
  pageNo?: number;
  limit?: number;
}

export interface IGetBriefTotalAggregation {
  payments: IGetBriefPaymentAggregation;
  ledger: IGetBriefLedgerAggregation;
  invoice: IGetBriefInvoiceAggregation;
}
